export const POPULAR_SEARCHES = [
  { rank: 1, labelKey: 'search.popular.sleep' },
  { rank: 2, labelKey: 'search.popular.focus' },
  { rank: 3, labelKey: 'search.popular.stress' },
  { rank: 4, labelKey: 'search.popular.diet' },
  { rank: 5, labelKey: 'search.popular.whiteNoise' },
  { rank: 6, labelKey: 'search.popular.meditation' },
  { rank: 7, labelKey: 'search.popular.library' },
  { rank: 8, labelKey: 'search.popular.brainwave' },
] as const;
